export const printPrice = (
  amountX100 = 0,
  currentSymbol = "€",
  precision = 2
) => {
  const formatPrice = `${(amountX100 / 100).toFixed(precision)}`;
  const [euros, cents] = formatPrice.split(".");
  if (cents === "00") return `${euros}${currentSymbol}`;
  return `${formatPrice}${currentSymbol}`;
};

export const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const timeConvert = (n) => {
  var hours = n / 60;
  var rhours = Math.floor(hours);
  var minutes = (hours - rhours) * 60;
  var rminutes = Math.round(minutes);
  return rhours + "h" + rminutes + "m";
};
